import React from "react";
import { ComponentStory, ComponentMeta } from "@storybook/react";
import { Stepper } from "../Stepper";

const commonArgs: React.ComponentProps<typeof Stepper> = {
    currentStepIndex: 0,
    size: "sm",
    translate: s => s,
    steps: [
        { description: "First step description", title: "First step" },
        { description: "Second step description", title: "Second Step" },
        { description: "Third step description", title: "Third step" }
    ]
};

export default {
    title: "v2/Stepper",
    component: Stepper,
    args: commonArgs
} as ComponentMeta<typeof Stepper>;

const Template: ComponentStory<typeof Stepper> = args => {
    return (
        <div>
            <Stepper {...args} />
        </div>
    );
};

export const Default = Template.bind({});

export const Dark = Template.bind({});
Dark.parameters = {
    theme: "darkTheme"
};
